import { appliances } from "../constants/resiliency/appliances";
import { calculations } from "../constants/resiliency/calculations";
import { generators } from "../constants/resiliency/generators";

function addSelectionType(item, selectionType) {
    return {
        "selectionType" : selectionType,
        ...item
    };
}

export function generatorCalc(sqft, monthlyBill, appliancelist) {
    let applianceSum = 0;

    appliances.forEach((item) => {
        if(appliancelist.find((innerItem) => (innerItem === item.name)))
            applianceSum += item.value;
    });

    return calculations.baseGeneratorSize 
        - calculations.baseApplianceOffset 
        + (calculations.wattsPerSquareFoot * sqft) 
        + (calculations.electricBillFactor * monthlyBill) 
        + applianceSum;
}

export function suggestGenerators(kW) {
    const lowerGenerators = generators.filter((item) => (item.wattage < kW)).sort((a, b) => (a.wattage - b.wattage));
    const higherGenerators = generators.filter((item) => (item.wattage >= kW)).sort((a, b) => (a.wattage - b.wattage));

    if(higherGenerators.length === 0)
        return {
            "bestFit" : lowerGenerators.length > 0 ? addSelectionType(lowerGenerators[lowerGenerators.length-1], "bestFit") : false,
        }
    else
        return {
            "budget" : lowerGenerators.length > 0 ? addSelectionType(lowerGenerators[lowerGenerators.length-1], "budget") : false,
            "bestFit": higherGenerators.length > 0 ? addSelectionType(higherGenerators[0], "bestFit") : false,
            "upgrade": higherGenerators.length > 1 ? addSelectionType(higherGenerators[1], "upgrade") : false,
        };

}